module.exports = __webpack_public_path__ + "img/corpse_reviver2.78feb7d4.jpg";